<template>
  <div class="venueWineDetails">
    <div class="box">
      <b-row>
        <b-col cols="6">poolinq-id</b-col>
        <b-col cols="6">{{ $t('general.bottleSize') }}</b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col cols="6">{{ venueWine.id }}</b-col>
        <b-col cols="6" v-if="venueWine.attributes.bottleSize != null">
          <span v-if="venueWine.attributes.bottleSize.data">{{
            venueWine.attributes.bottleSize.data.attributes.title }}</span>
          <span v-else>{{
            venueWine.attributes.bottleSize.title }}</span>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="smallText" cols="6">{{ $t('general.country') }}</b-col>
        <b-col class="smallText" cols="6">{{ $t('general.region') }}</b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col cols="6" v-if="venueWine.attributes.wine.data.attributes.land">{{ $t('countries.' +
          venueWine.attributes.wine.data.attributes.land.data.attributes.localeKey) }}</b-col>

        <b-col cols="6" v-if="venueWine.attributes.wine.data.attributes.region">{{
          venueWine.attributes.wine.data.attributes.region.data.attributes.localeKey ? $t('regions.' +
            venueWine.attributes.wine.data.attributes.region.data.attributes.localeKey) :
            venueWine.attributes.wine.data.attributes.region.data.attributes.title }}</b-col>
      </b-row>

      <b-row>
        <b-col class="smallText" cols="6">{{ $t('general.color') }}</b-col>
        <b-col class="smallText" cols="6">{{ $t('general.grapeVariety') }}</b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col cols="6" v-if="venueWine.attributes.wine.data.attributes.wineType">{{
          venueWine.attributes.wine.data.attributes.wineType.data.attributes.title }}</b-col>
        <b-col cols="6" v-if="venueWine.attributes.wine.data.attributes.grapeVariety">{{
          venueWine.attributes.wine.data.attributes.grapeVariety.data.attributes.title }}</b-col>
      </b-row>

      <PurchasePrices :venueSupplierOptions="venueSupplierOptions" :purchasePrices="filterDeletedPurchasePrices"
        :currency="getCurrency" />

      <SellingPrices :selectedWine="venueWine" :currency="getCurrency" />

      <div class="spacer s" />

      <b-row>
        <b-col>
          <h3>{{ $t('general.tastingNote') }}</h3>
          <textarea disabled :value="venueWine.attributes.comments"></textarea>
        </b-col>
      </b-row>

      <div class="spacer s" />

      <PosArticleList :posArticleNumberList="venueWine.attributes.posArticleNumberList" />

      <div class="spacer s" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DataService from '@/services/StrapiService'
import PurchasePrices from '@/components/wineDetail/PurchasePrices.vue'
import SellingPrices from '@/components/wineDetail/SellingPrices.vue'
import PosArticleList from '@/components/wineDetail/PosArticleList.vue'
import * as Utils from '@/utils/functions'

export default {
  name: 'VenueWineDetails',
  components: {
    PurchasePrices,
    SellingPrices,
    PosArticleList,
  },
  props: {
    venueWine: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      venueSupplierOptions: [],
      purchasePrices: [],
    }
  },
  computed: {
    ...mapGetters(['getVenue']),
    getCurrency() {
      return Utils.getVenueCurrency(this.getVenue)
    },
    filterDeletedPurchasePrices() {
      return Utils.getNotDeletedPurchasePrices(this.purchasePrices)
    },
  },
  created() {
    this.venueSupplierOptions = Utils.loadVenueSupplierOptions(this.getVenue)
    // The list endpoint does not populate purchasePrices, so load the
    // full venue wine detail to get them.
    DataService.getVenueWineDetail(this.venueWine.id).then((result) => {
      const attributes = result['data'].data.attributes
      this.purchasePrices = attributes.purchasePrices || []
    }).catch((err) => {
      console.log(err)
    })
  },
}
</script>

<style scoped>
.venueWineDetails .box {
  padding: 10px;
}

.venueWineDetails textarea {
  width: 100%;
  min-height: 80px;
  background: transparent;
  color: var(--color-white);
  border: 1px solid var(--color-gray-300);
  border-radius: 4px;
  padding: 6px;
}
</style>
